import { render, staticRenderFns } from "./AuthAlert.vue?vue&type=template&id=2b953860&scoped=true&"
import script from "./AuthAlert.vue?vue&type=script&lang=ts&"
export * from "./AuthAlert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b953860",
  null
  
)

export default component.exports